
<div *ngIf="showForm">
  <p-confirmDialog></p-confirmDialog>
<p-dialog
  [header]="dialogHeader"
  [(visible)]="showForm"
  [breakpoints]="{ '960px': '75vw' }"
  [style]="{ width: '90vw', height: '80vh', top: '1.5rem' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeDialog()"
  [maximizable]="true"
>
  <div class="card" [formGroup]="validateForm">
    <div class="flex flex-column gap-2">

      <label for="availableToAdministrativeGestion">Tipo Solicitud</label>
      <p-selectButton
        [options]="applicationTypeOptions"
        formControlName="applicationType"
        optionLabel="label"
        optionValue="value"
        (onChange)="onChangeApplicationType($event)"
      ></p-selectButton>

      <label for="">Productos y Servicios*</label>
      <p-multiSelect
        display="chip"
        [displaySelectedLabel]="true"
        [showClear]="true"
        [style]="{ display: 'flex' }"
        [options]="paymentItems"
        formControlName="applicationPaymentItems"
        optionLabel="product"
        inputId="applicationPaymentItems"
      ></p-multiSelect>

      <label for="applicantIdType">Tipo Identificación</label>
      <p-dropdown
        [options]="idTypes"
        formControlName="applicantIdType"
        optionLabel="name"
        optionValue="value"
      ></p-dropdown>

      <label for="applicantIdNumber">Número Identificación</label>
      <input
        type="text"
        pInputText
        placeholder="Ingrese numero Identificación"
        formControlName="applicantIdNumber"
      />

      <label for="applicantName">Nombre</label>
      <input
        type="text"
        pInputText
        placeholder="Ingrese nombre del solicitante"
        formControlName="applicantName"
      />

      <label for="applicantLastName">Apellido</label>
      <input
        type="text"
        pInputText
        placeholder="Ingrese apellido del solicitante"
        formControlName="applicantLastName"
      />

      <label for="applicantEmail">Email</label>
      <input
        type="text"
        pInputText
        placeholder="Ingrese apellido del solicitante"
        formControlName="applicantEmail"
      />

      <label for="applicantPhone">Teléfono</label>
      <input
        type="text"
        pInputText
        placeholder="Ingrese teléfono del solicitante"
        formControlName="applicantPhone"
      />

      <label for="applicantbirthDay">Fecha Nacimiento</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha de nacimiento del solicitante"
        formControlName="applicantbirthDay"
      />

      <label for="applicantGender">Género</label>
      <p-selectButton
        [options]="genderTypes"
        formControlName="applicantGender"
        optionLabel="name"
        optionValue="value"
      ></p-selectButton>

      <label for="applicantInsurance">EPS/Aseguradora</label>
      <input
        type="text"
        pInputText
        placeholder="Eps o aseguradora del solicitante"
        formControlName="applicantInsurance"
      />

      <label for="applicationLevel">Nivel</label>
      <p-selectButton
        [options]="levelTypes"
        formControlName="applicationLevel"
        optionLabel="name"
        optionValue="value"
      ></p-selectButton>

      <label for="applicationRole">Rol</label>
      <p-dropdown
        [options]="roles"
        formControlName="applicationRole"
        optionLabel="name"
        optionValue="value"
      ></p-dropdown>

      <label for="applicationModality">Modalidad</label>
      <p-dropdown
        [options]="modalidades"
        formControlName="applicationModality"
        optionLabel="name"
        optionValue="value"
      ></p-dropdown>
    </div>

    <div class="flex mt-2 gap-2 justify-content-end">
      <p-button
        label="Cancelar"
        [outlined]="true"
        severity="secondary"
        [rounded]="true"
        (click)="closeDialog()"
      ></p-button>
      <p-button
        type="submit"
        label="Guardar"
        [rounded]="true"
        [disabled]="validateForm.invalid"
        (click)="initUpdateApplication($event)"
      ></p-button>
    </div>
  </div>
</p-dialog>

</div>